export const init = () => {
  const enhancedContactBoxSets = document.querySelectorAll('.s-enhanced-contact-box-set');

  if (!enhancedContactBoxSets.length) return;

  enhancedContactBoxSets.forEach(set => {
    const actionButton = set.querySelector('.s-enhanced-contact-box-set__action button');
    const contentWrapper = set.querySelector('.s-enhanced-contact-box-set__wrapper[data-content="international"]');
    const { textShow, textHide } = actionButton.dataset;

    actionButton.addEventListener('click', () => {
      const buttonText = actionButton.lastElementChild;
      buttonText.innerText = buttonText.innerText === textShow ? textHide : textShow;
      actionButton.classList.toggle('active');
      contentWrapper.classList.toggle('active');
      if (contentWrapper.classList.contains('active')) {
        contentWrapper.style.maxHeight = `${contentWrapper.scrollHeight + 16}px`;
      } else {
        contentWrapper.style.maxHeight = 0;
      }
    });
  });
}